import { render, staticRenderFns } from "./DrawerIframe.vue?vue&type=template&id=45fc4433&scoped=true&"
import script from "./DrawerIframe.vue?vue&type=script&lang=js&"
export * from "./DrawerIframe.vue?vue&type=script&lang=js&"
import style0 from "./DrawerIframe.vue?vue&type=style&index=0&id=45fc4433&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc4433",
  null
  
)

export default component.exports